export const groupChats = (chats) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneWeekAgo = new Date(today);
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

  const groups = {
    Today: [],
    'Previous Week': [],
    'Previous 30 Days': [],
  };

  chats.forEach(chat => {
    if (!chat.created_at) {
      groups['Invalid Date'].push(chat);
      return;
    }

    const chatDate = new Date(chat.created_at);
    if (isNaN(chatDate.getTime())) {
      groups['Invalid Date'].push(chat);
      return;
    }

    chatDate.setHours(0, 0, 0, 0);

    if (chatDate.getTime() === today.getTime()) {
      groups.Today.push(chat);
    } else if (chatDate >= oneWeekAgo) {
      groups['Previous Week'].push(chat);
    } else if (chatDate >= thirtyDaysAgo) {
      groups['Previous 30 Days'].push(chat);
    } else {
      const monthYear = chatDate.toLocaleString('default', { month: 'long', year: 'numeric' });
      if (!groups[monthYear]) {
        groups[monthYear] = [];
      }
      groups[monthYear].push(chat);
    }
  });

  return groups;
};
